<div *ngIf="currentPage$ | async" class="main-top-bar-container">
  <!-- Page Title -->
  <div class="page-title">
    <h2>
      <i
        (click)="onIconClick()"
        [ngClass]="(currentPage$ | async)?.icon"
        [class.clickable]="(currentPage$ | async)?.activateRoute"
      ></i>
      {{ topBarName ? topBarName : (currentPage$ | async)?.title }}
    </h2>
  </div>

  <!-- Page Bar Content -->
  <div class="page-bar-content">
    <ng-content></ng-content>
  </div>
</div>
